import React, { useState, useEffect, useRef } from "react";
import { database } from "../../firebase";
import { ref, onValue, orderByChild, set, update, equalTo, limitToLast } from "firebase/database";
import { getFirestore, collection, addDoc, updateDoc, orderBy, getDocs, limit, setDoc, doc, where, query as queryFire, runTransaction, serverTimestamp, getDoc } from "firebase/firestore";
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import CircularProgress from '@mui/material/CircularProgress';
import { read, utils, write } from 'xlsx';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
import { tipoRemito, tipoDeco } from "../../utils/default";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { idCuadrillaNucleo } from '../../utils/default';
import FacturaRemito from "./FacturaRemito";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { getCuadrillasOnce, updateCuadrillaFirestore, invalidateCuadrillasCache } from "../../services/cuadrillasService";
import { registrarTransferenciaSeriales } from "../../services/registrosService";
import { getMaterialesOnce } from "../../services/materialsService";
import { Typography } from "@mui/material";

const firestore = getFirestore();
const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddRemito() {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const [serialesIndex, setSerialesIndex] = useState(0)
    const [serialInputValue, setSerialInputValue] = useState('')
    const justAutoSelectedRef = useRef(false)
    const [state, setState] = useState({
        lastId: -1,
        materials: [],
        materialsToSave: [],
        serialesToSave: [],
        controlsToSave: [],
        cuadrillaEntrega: '',
        cuadrillaReceptora: '',
        tipoRemito: 'ENTREGA',
        date: moment(new Date().getTime()),
        observaciones: '',
        shelfPosition: '', // New state for shelf position
        manualShelfPosition: '', // New state for manual shelf position

    })
    const [serialesToSelect, setSerialesToSelect] = useState([]);
    const [serialesCuadrillaDestino, setSerialesCuadrillaDestino] = useState([]);
    const [controlsDestino, setControlsDestino] = useState([]);
    const [controlsEntrega, setControlsEntrega] = useState([]);
    const [cuadrillas, setCuadrillas] = useState([]);
    let [newSerialesEntrega, setNewSerialesEntrega] = useState([]);
    const [openModalSee, setOpenModalSee] = useState(false);
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });
    const [openPreviewModal, setOpenPreviewModal] = useState(false);
    const [materialsCuadrillaReceptora, setMaterialsCuadrillaReceptora] = useState([]);
    // const [controlesSaveReceptora, setControlesSaveReceptora] = useState([]);
    const [spinner, setSpinner] = useState(false)
    const [saveOk, setSaveOk] = useState(false)
    const [serialesVerificados, setSerialesVerificados] = useState([])
    const [cuadrillaReceptoraInfo, setCuadrillaReceptoraInfo] = useState(null)
    const shelfPositionOptions = [
        'A1', 'A2', 'A3', 'A4', 'A5', 'A6',
        'B1', 'B2', 'B3', 'B4', 'B5', 'B6',
        'C1', 'C2', 'C3', 'C4', 'C5', 'C6',
        'Otra'
    ];




    const onChangeValues = (e, index) => {
        let value = e?.target.value;
        const name = e?.target.name;
        if (typeof value === 'string') {
            if (name === 'id') value = value.trim();
            else if (name === 'tipo') value = value.trim().toLowerCase();
        }
        const fechaActual = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm");
        
        // ✅ ARREGLADO: Crear nueva copia del array en lugar de mutación directa
        setState(prevState => {
            const newSerialsToSave = [...(prevState.serialesToSave || [])];
            
            if (newSerialsToSave[index]) {
                newSerialsToSave[index] = { 
                    ...newSerialsToSave[index], 
                    [name]: value,
                    fechaUltimaModificacion: fechaActual // ✅ NUEVO: Actualizar fecha de última modificación
                };
            } else {
                newSerialsToSave[index] = { 
                    [name]: value,
                    fechaUltimaModificacion: fechaActual // ✅ NUEVO: Agregar fecha de última modificación
                };
            }
            
            return { ...prevState, serialesToSave: newSerialsToSave };
        });
    };

    const onAddBtnClick = (e, type) => {
        e.preventDefault();
        setSerialConfigList(serialConfigList.concat(inputSerials));
        setSerialesIndex(serialConfigList.length)
    };

    const onChangeTipoSerial = (e, tipo, index) => {
        e.preventDefault();
        const value = typeof tipo === 'string' ? tipo.trim().toLowerCase() : tipo;
        const fechaActual = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm");
        
        // ✅ ARREGLADO: Crear nueva copia del array en lugar de mutación directa
        setState(prevState => {
            const newSerialsToSave = [...(prevState.serialesToSave || [])];
            
            if (newSerialsToSave[index]) {
                newSerialsToSave[index] = { 
                    ...newSerialsToSave[index], 
                    tipo: value,
                    fechaUltimaModificacion: fechaActual // ✅ NUEVO: Actualizar fecha de última modificación
                };
            } else {
                newSerialsToSave[index] = { 
                    tipo: value,
                    fechaUltimaModificacion: fechaActual // ✅ NUEVO: Agregar fecha de última modificación
                };
            }
            
            return { ...prevState, serialesToSave: newSerialsToSave };
        });
    }

    const onChangeSelectCuadrilla = (event, cuadrilla) => {
        const nroCuadrilla = cuadrilla.numero;
        const idCuadrilla = cuadrilla.id;
        setState(prevState => ({ ...prevState, cuadrilla: nroCuadrilla, idCuadrilla }));
    }

    const onChangeFechaAsistencia = (value, index) => {
        const fechaActual = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm");
        const fechaAsistenciaFormatted = value && moment(value).isValid()
            ? moment(value).format("DD/MM/YYYY")
            : '';
        setState(prevState => {
            const newSerialsToSave = [...(prevState.serialesToSave || [])];
            if (newSerialsToSave[index]) {
                newSerialsToSave[index] = {
                    ...newSerialsToSave[index],
                    fechaAsistencia: fechaAsistenciaFormatted,
                    fechaUltimaModificacion: fechaActual,
                };
            } else {
                newSerialsToSave[index] = {
                    fechaAsistencia: fechaAsistenciaFormatted,
                    fechaUltimaModificacion: fechaActual,
                };
            }
            return { ...prevState, serialesToSave: newSerialsToSave };
        });
    };

    const inputSerials = (index, serialCharge) => {
        const isDevolucion = state.tipoRemito === 'DEVOLUCION';
        const disabled = !state?.serialesToSave[index]?.tipo;
        return [
            <Box
                key={index}
                sx={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    gap: '8px',
                    width: '100%',
                    marginBottom: '8px',
                    paddingBottom: isDevolucion ? '8px' : 0,
                    borderBottom: isDevolucion ? '1px dashed #e0e0e0' : 'none',
                }}
            >
                <FormControl sx={{ flex: isDevolucion ? '0 0 14%' : '0 0 25%' }}>
                    <Autocomplete
                        options={tipoDeco}
                        id="disable-clearable"
                        value={serialCharge?.tipo || ''}
                        onChange={(e, tipo) => onChangeTipoSerial(e, tipo, index)}
                        getOptionLabel={(option) => option?.toUpperCase()}
                        isOptionEqualToValue={(option, value) => option === value || value === ''}
                        fullWidth
                        renderInput={(params) => (
                            <TextField {...params} label="Tipo" placeholder="Tipo" />
                        )}
                    />
                </FormControl>
                <TextField
                    label="Serial"
                    disabled={disabled}
                    className="text-form__serial"
                    onChange={(e) => onChangeValues(e, index)}
                    name="id"
                    InputLabelProps={{ shrink: true }}
                    sx={{ flex: isDevolucion ? '0 0 18%' : '0 0 30%' }}
                    defaultValue={serialCharge?.id || ''}
                />
                {isDevolucion && (
                    <>
                        <TextField
                            label="NRO WO"
                            disabled={disabled}
                            className="text-form__serial"
                            onChange={(e) => onChangeValues(e, index)}
                            name="nroWO"
                            InputLabelProps={{ shrink: true }}
                            sx={{ flex: '0 0 18%' }}
                            defaultValue={serialCharge?.nroWO || ''}
                        />
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Fecha de asistencia"
                                inputFormat="DD/MM/YYYY"
                                disabled={disabled}
                                value={serialCharge?.fechaAsistencia ? moment(serialCharge.fechaAsistencia, "DD/MM/YYYY") : null}
                                onChange={(value) => onChangeFechaAsistencia(value, index)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={{ flex: '0 0 22%', minWidth: 0 }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </>
                )}
                <TextField
                    label="Observaciones"
                    disabled={disabled}
                    className="text-form__serial"
                    onChange={(e) => onChangeValues(e, index)}
                    name="observaciones"
                    InputLabelProps={{ shrink: true }}
                    sx={{ flex: isDevolucion ? '1 1 22%' : '1 1 38%' }}
                    defaultValue={serialCharge?.observaciones || ''}
                />
            </Box>
        ];
    };

    const [serialConfigList, setSerialConfigList] = useState(inputSerials);

    useEffect(() => {
        // onValue(ref(database, '/materiales/'), (snapshot) => {
        //     setState(prevState => ({ ...prevState, materials: snapshot.val() }));
        // }, {
        //     onlyOnce: true
        // });
        getMaterialesOnce(setState);

        // const topUserPostsRef = query(ref(database, 'remitos'), orderByChild('id'), limitToLast(1));
        // onValue(topUserPostsRef, (snapshot) => {
        //     const key = snapshot.val() ? Object.keys(snapshot.val()) : 0;
        //     setState(prevState => ({ ...prevState, lastId: parseInt(key, 10) }));
        // }, {
        //     onlyOnce: true
        // });
        // // onValue(ref(database, '/cuadrillas/'), (snapshot) => {
        //     setCuadrillas(Object.values(snapshot.val()))
        // }, {
        //     onlyOnce: true
        // });
        getCuadrillasOnce(setCuadrillas)
    }, []);

    const changeInput = (e, id, name) => {
        const value = e?.target.value;
        const formatData = { id, name, value }
        const filterService = state.materialsToSave.filter(service => service?.id === id);
        let newData = [];
        const keys = Object.keys(state.materialsToSave);
        if (filterService.length > 0) {
            let materialNewArray = [...state.materialsToSave]
            const keyService = keys.filter(key => state.materialsToSave[key]?.id === id);
            let materialToEdit = { ...materialNewArray[keyService] };
            materialToEdit.value = value
            materialNewArray[keyService] = materialToEdit
            setState(prevState => ({ ...prevState, materialsToSave: materialNewArray }));
        } else {
            newData = [...state.materialsToSave, formatData]
            setState(prevState => ({ ...prevState, materialsToSave: newData }));
        }

        if (value === '') {
            let materialNewArray = [...state.materialsToSave]
            const keyService = keys.filter(key => state.materialsToSave[key]?.id === id);
            materialNewArray.splice(parseInt(keyService[0], 10), 1);
            setState(prevState => ({ ...prevState, materialsToSave: materialNewArray }));
        }
    }

    const changeObservationsMaterials = (e, id) => {
        const filterService = state.materialsToSave.filter(service => service?.id === id);
        const keys = Object.keys(state.materialsToSave);
        if (filterService.length > 0) {
            let materialNewArray = [...state.materialsToSave]
            const keyService = keys.filter(key => state.materialsToSave[key]?.id === id);
            let materialToEdit = { ...materialNewArray[keyService] };
            materialToEdit.observaciones = e?.target.value
            materialNewArray[keyService] = materialToEdit
            setState(prevState => ({ ...prevState, materialsToSave: materialNewArray }));
        }
    }

    const onChangeDate = (value) => {
        setState(prevState => ({ ...prevState, date: value }));
    };

    const getCuadrillasDyO = async (idCuadrilla, setCuadrillaState, setControlState) => {
        const cuadrillasCollection = collection(firestore, 'cuadrillas');
        const q = queryFire(cuadrillasCollection, where('id', '==', idCuadrilla));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
                const serials = doc.data()?.seriales || [];
                const controles = doc.data()?.controles || [];
                setCuadrillaState(serials)
                setControlState(controles)
            });
        } else {
            console.log("No se encontró ningún documento con ese id.");
        }
    }

    const fetchMaterialsCuadrilla = async (idCuadrilla, setFuction) => {
        let materialsCuadrilla = [];
        try {
            // Referencia a la colección
            const materialsCuadrillaCollection = collection(firestore, 'materialsxcuadrilla');

            // Consulta con filtro por idCuadrilla
            const cuadrillaQuery = queryFire(
                materialsCuadrillaCollection,
                where('idCuadrilla', '==', parseInt(idCuadrilla, 10))
            );

            // Obtener los documentos de la consulta
            const querySnapshot = await getDocs(cuadrillaQuery);
            console.log('querySnapshot', querySnapshot, idCuadrilla);

            if (!querySnapshot.empty) {
                // Extraer los datos de los documentos
                materialsCuadrilla = querySnapshot.docs.map(doc => doc.data());
            }
            if (setFuction) {
                setFuction(materialsCuadrilla);
            }
        } catch (error) {
            console.error('Error al obtener materialsxcuadrilla:', error);
            if (setFuction) {
                setFuction([]);
            }
            setSnackbarInfo({ text: 'Ocurrió un error al cargar los materiales', type: 'error', open: true });
        }
        return materialsCuadrilla;
    };

    const onChangeCuadrillaDestino = async (event, cuadrilla) => {
        const idCuadrilla = cuadrilla.id;
        setState(prevState => ({ ...prevState, cuadrillaReceptora: idCuadrilla }));
        getCuadrillasDyO(idCuadrilla, setSerialesCuadrillaDestino, setControlsDestino)

        fetchMaterialsCuadrilla(idCuadrilla, setMaterialsCuadrillaReceptora);

        // const receptora = query(ref(database, 'cuadrillas'), orderByChild('id'), equalTo(idCuadrilla));
        // onValue(receptora, (snapshot) => {
        //     const serials = Object.values(snapshot.val())[0]?.seriales || [];
        //     const controles = Object.values(snapshot.val())[0]?.controles || [];
        //     setSerialesCuadrillaDestino(serials)
        //     setControlsDestino(controles)
        // }, {
        //     onlyOnce: true
        // });
        // const cuadrillaReceptora = query(ref(database, 'materialsxcuadrilla'), orderByChild('idCuadrilla'), equalTo(idCuadrilla));
        // onValue(cuadrillaReceptora, (snapshot) => {
        //     const materialsCuadRec = snapshot.val() ? Object.values(snapshot.val()) : [];
        //     setMaterialsCuadrillaReceptora(materialsCuadRec);
        // }, {
        //     onlyOnce: true
        // });
    };

    const onChangeCuadrillaEntrega = async (event, cuadrilla) => {
        const idCuadrilla = cuadrilla.id;
        setState(prevState => ({ ...prevState, cuadrillaEntrega: idCuadrilla }));
        getCuadrillasDyO(idCuadrilla, setSerialesToSelect, setControlsEntrega)

        // const bodega = query(ref(database, 'cuadrillas'), orderByChild('id'), equalTo(idCuadrilla));
        // onValue(bodega, (snapshot) => {
        //     const serials = Object.values(snapshot.val())[0]?.seriales || [];
        //     const controles = Object.values(snapshot.val())[0]?.controles || [];
        //     setSerialesToSelect(serials)
        //     setControlsEntrega(controles)
        // }, {
        //     onlyOnce: true
        // });

    };

    const onChangeTipoRemito = (e) => {
        setState(prevState => ({ ...prevState, tipoRemito: e?.target.value }));
    }

    const onChangeShelfPosition = (event, value) => {
        setState(prevState => ({ ...prevState, shelfPosition: value }));
        if (value !== 'Otra') {
            setState(prevState => ({ ...prevState, manualShelfPosition: '' }));
        }
    };

    const onChangeManualShelfPosition = (e) => {
        setState(prevState => ({ ...prevState, manualShelfPosition: e.target.value }));
    };

    const getShelfPositionDisplay = () => {
        if (state.shelfPosition === 'Otra') {
            return state.manualShelfPosition || '';
        }
        return state.shelfPosition || '';
    };

    const getShelfPositionAbbreviation = () => {
        const pos = getShelfPositionDisplay();
        return pos ? `P.E: ${pos}` : '';
    };

    const onChangeSeriales = (event, serialsSelected) => {
        setState(prevState =>
        ({
            ...prevState,
            serialesToSave: (serialsSelected || []).map(s => ({
                ...s,
                id: s?.id !== undefined && s?.id !== null ? String(s.id).trim() : '',
                tipo: s?.tipo ? String(s.tipo).trim().toLowerCase() : ''
            })),
        }));
    }

    const onSerialInputChange = (_event, newInputValue, reason) => {
        setSerialInputValue(newInputValue);

        if (reason === 'input' && newInputValue) {
            const trimmedInput = newInputValue.trim();
            const exactMatches = serialesToSelect.filter(
                option => String(option.id).trim() === trimmedInput &&
                !state.serialesToSave.some(s => String(s.id).trim() === trimmedInput)
            );
            if (exactMatches.length === 1) {
                justAutoSelectedRef.current = true;
                onChangeSeriales(null, [...state.serialesToSave, exactMatches[0]]);
                setSerialInputValue('');
            }
        }
    };

    const onChangeObservationSeriales = (event, serial) => {
        const value = event.target.value;

        const indexSerial = state.serialesToSave.findIndex((obj) => obj?.id === serial);
        state.serialesToSave[indexSerial].observaciones = value

        setState(prevState => ({ ...prevState }));
    }

    const onChangeNroWOSerial = (event, serial) => {
        const value = event.target.value;
        setState(prevState => {
            const newList = [...(prevState.serialesToSave || [])];
            const idx = newList.findIndex((obj) => obj?.id === serial);
            if (idx >= 0) {
                newList[idx] = { ...newList[idx], nroWO: value };
            }
            return { ...prevState, serialesToSave: newList };
        });
    }

    const onChangeFechaAsistenciaSerial = (value, serial) => {
        const fechaAsistenciaFormatted = value && moment(value).isValid()
            ? moment(value).format("DD/MM/YYYY")
            : '';
        setState(prevState => {
            const newList = [...(prevState.serialesToSave || [])];
            const idx = newList.findIndex((obj) => obj?.id === serial);
            if (idx >= 0) {
                newList[idx] = { ...newList[idx], fechaAsistencia: fechaAsistenciaFormatted };
            }
            return { ...prevState, serialesToSave: newList };
        });
    }

    const onChangeControles = (e, id, name) => {
        const valued = e.target.value
        const value = valued && parseInt(valued, 10)
        const formatData = { id, name, value }
        const filterService = state.controlsToSave.filter(service => service?.id === id);
        let newData = [];
        const keys = Object.keys(state.controlsToSave);
        if (filterService.length > 0) {
            let materialNewArray = [...state.controlsToSave]
            const keyService = keys.filter(key => state.controlsToSave[key]?.id === id);
            let materialToEdit = { ...materialNewArray[keyService] };
            materialToEdit.value = value
            materialNewArray[keyService] = materialToEdit
            setState(prevState => ({ ...prevState, controlsToSave: materialNewArray }));
        } else {
            newData = [...state.controlsToSave, formatData]
            setState(prevState => ({ ...prevState, controlsToSave: newData }));
        }

        if (value === '') {
            let materialNewArray = [...state.controlsToSave]
            const keyService = keys.filter(key => state.controlsToSave[key]?.id === id);
            console.log();

            materialNewArray.splice(parseInt(keyService[0], 10), 1);
            setState(prevState => ({ ...prevState, controlsToSave: materialNewArray }));
        }
    };

    const formatRemitoToSave = (lastId) => {
        const cuadrillaEntregaObj = cuadrillas.find(cuad => String(cuad?.id) === String(state.cuadrillaEntrega));
        const cuadrillaReceptoraObj = cuadrillas.find(cuad => String(cuad?.id) === String(state.cuadrillaReceptora));
        const nameCuadrillaEntrega = cuadrillaEntregaObj?.numero;
        const nameCuadrillaReceptora = cuadrillaReceptoraObj?.numero;
        const dateHour = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm")

        const sanitizedSerials = (state.serialesToSave || []).map(s => ({
            ...s,
            id: s?.id !== undefined && s?.id !== null ? String(s.id).trim() : '',
            tipo: s?.tipo ? String(s.tipo).trim().toLowerCase() : '',
            observaciones: s?.observaciones !== undefined && s?.observaciones !== null ? String(s.observaciones).trim() : ''
        }));

        const dataRemitoToSave = {
            id: lastId + 1,
            materials: state.materialsToSave,
            serials: sanitizedSerials,
            tipoRemito: state.tipoRemito,
            controles: state.controlsToSave,
            fecha: moment(state.date).format("YYYYMMDD"),
            cuadrillaEntrega: nameCuadrillaEntrega,
            cuadrillaReceptora: nameCuadrillaReceptora,
            idCuadrillaEntrega: state.cuadrillaEntrega,
            idCuadrillaReceptora: state.cuadrillaReceptora,
            observaciones: state.observaciones,
            shelfPosition: getShelfPositionDisplay(), // Add shelf position
            confectionDate: dateHour
        };
        if (cuadrillaEntregaObj?.usuario != null && cuadrillaEntregaObj.usuario !== '') {
            dataRemitoToSave.usuarioCuadrillaEntrega = cuadrillaEntregaObj.usuario;
        }
        if (cuadrillaReceptoraObj?.usuario != null && cuadrillaReceptoraObj.usuario !== '') {
            dataRemitoToSave.usuarioCuadrillaReceptora = cuadrillaReceptoraObj.usuario;
        }

        return dataRemitoToSave;
    }

    const saveOnlyRemito = async () => {
        const cuadrillaEntregaObj = cuadrillas.find(cuad => String(cuad?.id) === String(state.cuadrillaEntrega));
        const cuadrillaReceptoraObj = cuadrillas.find(cuad => String(cuad?.id) === String(state.cuadrillaReceptora));
        const nameCuadrillaEntrega = cuadrillaEntregaObj?.numero || '';
        const nameCuadrillaReceptora = cuadrillaReceptoraObj?.numero || '';
        const mailCuadrillaReceptora = cuadrillaReceptoraObj?.correoElectronico || null;
        const dateHour = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm");

        const sanitizedSerials = (state.serialesToSave || []).map(s => ({
            ...s,
            id: s?.id !== undefined && s?.id !== null ? String(s.id).trim() : '',
            tipo: s?.tipo ? String(s.tipo).trim().toLowerCase() : '',
            observaciones: s?.observaciones !== undefined && s?.observaciones !== null ? String(s.observaciones).trim() : ''
        }));

        const dataRemitoToSave = {
            materials: state.materialsToSave || [],
            serials: sanitizedSerials,
            tipoRemito: state.tipoRemito || '',
            controles: state.controlsToSave || [],
            fecha: state.date ? moment(state.date).format("YYYYMMDD") : moment().format("YYYYMMDD"),
            cuadrillaEntrega: nameCuadrillaEntrega,
            cuadrillaReceptora: nameCuadrillaReceptora,
            idCuadrillaEntrega: state.cuadrillaEntrega ?? '',
            idCuadrillaReceptora: state.cuadrillaReceptora ?? '',
            observaciones: state.observaciones || '',
            shelfPosition: getShelfPositionDisplay() || '',
            confectionDate: dateHour
        };
        if (cuadrillaEntregaObj?.usuario != null && cuadrillaEntregaObj.usuario !== '') {
            dataRemitoToSave.usuarioCuadrillaEntrega = cuadrillaEntregaObj.usuario;
        }
        if (cuadrillaReceptoraObj?.usuario != null && cuadrillaReceptoraObj.usuario !== '') {
            dataRemitoToSave.usuarioCuadrillaReceptora = cuadrillaReceptoraObj.usuario;
        }

        // Solo agregar el email si existe
        if (mailCuadrillaReceptora) {
            dataRemitoToSave.emailCuadrillaReceptora = mailCuadrillaReceptora;
        }

        const firestore = getFirestore();

        // Obtener el último ID
        const remitosCollectionRef = collection(firestore, "remitos");
        const q = queryFire(remitosCollectionRef, orderBy("id", "desc"), limit(1));
        const querySnapshot = await getDocs(q);

        let lastId = 0;

        if (!querySnapshot.empty) {
            querySnapshot.forEach((docSnap) => {
                const docData = docSnap.data();
                if (docData && docData.id) {
                    const parsed = parseInt(docData.id, 10);
                    if (!isNaN(parsed) && parsed > lastId) {
                        lastId = parsed;
                    }
                }
            });
        }

        // Guardar en una transacción
        const newId = lastId + 1;
        dataRemitoToSave.id = newId;
        setState(prevState => ({ ...prevState, lastId: newId }));

        await runTransaction(firestore, async (transaction) => {
            const newDocRef = doc(firestore, "remitos", newId.toString());
            transaction.set(newDocRef, dataRemitoToSave);
        });

        console.log("Nuevo documento guardado con éxito (remito)");
        return newId; // Devolver el ID generado
    };


    // DEPRECADO
    // const saveRemito = () => {
    //     setOpenPreviewModal(false);
    //     let lastId = state.lastId;

    //     // const topUserPostsRef = query(ref(database, 'remitos'), orderByChild('id'), limitToLast(1));
    //     // onValue(topUserPostsRef, (snapshot) => {
    //     //     const key = snapshot.val() ? Object.keys(snapshot.val()) : 0;
    //     //     lastId = parseInt(key, 10);
    //     //     setSpinner(true);
    //     // }, {
    //     //     onlyOnce: true
    //     // });
    //     const nameCuadrillaEntrega = cuadrillas.filter(cuad => cuad?.id === state.cuadrillaEntrega)[0]?.numero;
    //     const nameCuadrillaReceptora = cuadrillas.filter(cuad => cuad?.id === state.cuadrillaReceptora)[0]?.numero;

    //     // Llamadas

    //     // SE HACE LA LLAMADA ANTES EN EL METODO onChangeCuadrillaReceptora
    //     // let materialsCuadrillaReceptora = [];
    //     // const cuadrillaReceptora = query(ref(database, 'materialsxcuadrilla'), orderByChild('idCuadrilla'), equalTo(parseInt(state.cuadrillaReceptora, 10)));
    //     // onValue(cuadrillaReceptora, (snapshot) => {
    //     //     const materialsCuadRec = snapshot.val() ? Object.values(snapshot.val()) : [];
    //     //     materialsCuadrillaReceptora = materialsCuadRec;
    //     // }, {
    //     //     onlyOnce: true
    //     // });

    //     // const cuadrillaEmisora = query(ref(database, 'materialsxcuadrilla'), orderByChild('idCuadrilla'), equalTo(parseInt(state.cuadrillaEntrega, 10)));
    //     // onValue(cuadrillaEmisora, (snapshot) => {
    //     //     const materialsCuadEm = snapshot.val() ? Object.values(snapshot.val()) : [];
    //     //     materialsCuadrillaEmisora = materialsCuadEm;
    //     // }, {
    //     //     onlyOnce: true
    //     // });
    //     let materialsCuadrillaEmisora = [];
    //     fetchMaterialsCuadrilla(state.cuadrillaEntrega).then(materialsCuadrilla => {
    //         materialsCuadrillaEmisora = materialsCuadrilla;
    //     });

    //     let controlesCuadrillaReceptora = controlsDestino;
    //     let serialsCuadrillaReceptora = serialesCuadrillaDestino;

    //     // Escritura
    //     setTimeout(() => {

    //         let dataRemitoToSave = {
    //             // id: lastId + 1,
    //             materials: state.materialsToSave,
    //             serials: state.serialesToSave,
    //             tipoRemito: state.tipoRemito,
    //             controles: state.controlsToSave,
    //             fecha: moment(state.date).format("DD/MM/YYYY"),
    //             cuadrillaEntrega: nameCuadrillaEntrega,
    //             cuadrillaReceptora: nameCuadrillaReceptora,
    //             idCuadrillaEntrega: state.cuadrillaEntrega,
    //             idCuadrillaReceptora: state.cuadrillaReceptora,
    //             observaciones: state.observaciones,
    //         };
    //         saveOnlyRemito(dataRemitoToSave)
    //         // set(ref(database, 'remitos/' + dataRemitoToSave?.id), dataRemitoToSave)
    //         //     .then(() => {
    //         //         console.log('ok remitos rec')
    //         //     })
    //         //     .catch(() => setSnackbarInfo({ text: 'Ocurrió un error al guardar el remito', type: 'error', open: true }))

    //         state.materialsToSave.forEach(mate => {
    //             const filterMaterialsByCuadrilla = materialsCuadrillaReceptora.filter(
    //                 cuadrilla => cuadrilla?.idMaterial === parseInt(mate?.id, 10));

    //             if (filterMaterialsByCuadrilla.length > 0) {
    //                 filterMaterialsByCuadrilla.forEach(matxcuad => {
    //                     // const quantityStock = state.tipoRemito === 'ENTREGA' ? matxcuad.cantidad + parseInt(mate.value, 10) : matxcuad.cantidad - parseInt(mate.value, 10);
    //                     const quantityStock = matxcuad.cantidad + parseInt(mate.value, 10);
    //                     return (
    //                         update(ref(database, 'materialsxcuadrilla/' + matxcuad?.idCuadrilla + 'c' + matxcuad?.idMaterial),
    //                             { cantidad: quantityStock })
    //                             .then(() => {
    //                                 console.log('ok materialsxcuadrilla rec')
    //                             })
    //                             .catch((e) => {
    //                                 setSnackbarInfo({ text: 'Ocurrió un error al guardar los materiales', type: 'error', open: true })
    //                             })
    //                     )
    //                 })
    //             } else {
    //                 const idCuadrilla = parseInt(state.cuadrillaReceptora, 10);
    //                 const idMaterial = parseInt(mate?.id, 10);
    //                 const dataToStock = {
    //                     // cantidad: state.tipoRemito === 'ENTREGA' ? parseInt(mate.value, 10) : -parseInt(mate.value, 10),
    //                     cantidad: parseInt(mate.value, 10),
    //                     idCuadrilla,
    //                     idMaterial
    //                 }
    //                 set(ref(database, 'materialsxcuadrilla/' + idCuadrilla + 'c' + idMaterial), dataToStock)
    //                     .then(() => {
    //                         console.log('ok materialsxcuadrilla rec');
    //                     })
    //                     .catch(() => setSnackbarInfo({ text: 'Ocurrió un error al guardar los materiales', type: 'error', open: true }))
    //             }
    //         });

    //         state.materialsToSave.forEach(mate => {
    //             const filterMaterialsByCuadrilla = materialsCuadrillaEmisora.filter(
    //                 cuadrilla => cuadrilla?.idMaterial === parseInt(mate?.id, 10));

    //             if (filterMaterialsByCuadrilla.length > 0) {
    //                 filterMaterialsByCuadrilla.forEach(matxcuad => {
    //                     // const quantityStock = state.tipoRemito === 'ENTREGA' ? matxcuad.cantidad + parseInt(mate.value, 10) : matxcuad.cantidad - parseInt(mate.value, 10);
    //                     const quantityStock = matxcuad.cantidad - parseInt(mate.value, 10);
    //                     return (
    //                         update(ref(database, 'materialsxcuadrilla/' + matxcuad?.idCuadrilla + 'c' + matxcuad?.idMaterial),
    //                             { cantidad: quantityStock })
    //                             .then(() => {
    //                                 console.log('ok materialesxc emisora', quantityStock)
    //                             })
    //                             .catch((e) => {
    //                                 setSnackbarInfo({ text: 'Ocurrió un error al guardar los materiales', type: 'error', open: true })
    //                             })
    //                     )
    //                 })
    //             } else {
    //                 const idCuadrilla = parseInt(state.cuadrillaEntrega, 10);
    //                 const idMaterial = parseInt(mate?.id, 10);
    //                 const dataToStock = {
    //                     // cantidad: state.tipoRemito === 'ENTREGA' ? parseInt(mate.value, 10) : -parseInt(mate.value, 10),
    //                     cantidad: -parseInt(mate.value, 10),
    //                     idCuadrilla,
    //                     idMaterial
    //                 }
    //                 set(ref(database, 'materialsxcuadrilla/' + idCuadrilla + 'c' + idMaterial), dataToStock)
    //                     .then(() => {
    //                         console.log('ok materialsxcuadrilla emisora')
    //                     })
    //                     .catch(() => setSnackbarInfo({ text: 'Ocurrió un error al guardar los materiales', type: 'error', open: true }))
    //             }
    //         });

    //         // setTimeout(() => {
    //         const formatSerialsToSave = serialsCuadrillaReceptora.concat(state.serialesToSave)
    //         state.controlsToSave.forEach(control => {
    //             const filterTipoControl = controlesCuadrillaReceptora.filter(cont => cont?.id === control?.id)
    //             let newControlSave = [];
    //             const keys = Object.keys(controlesCuadrillaReceptora);
    //             if (filterTipoControl.length > 0) {
    //                 let materialNewArray = [...controlesCuadrillaReceptora]
    //                 const keyService = keys.filter(key => controlesCuadrillaReceptora[key]?.id === control?.id);
    //                 let materialToEdit = { ...materialNewArray[keyService] };
    //                 materialToEdit.value += control.value
    //                 materialNewArray[keyService] = materialToEdit
    //                 controlesCuadrillaReceptora = materialNewArray;
    //             } else {
    //                 newControlSave = [...controlesCuadrillaReceptora, control]
    //                 controlesCuadrillaReceptora = newControlSave;
    //             }
    //         })

    //         const dataUpdateCuadrillaReceptora = { seriales: formatSerialsToSave, controles: controlesCuadrillaReceptora }
    //         updateCuadrillaFirestore(state.cuadrillaReceptora, dataUpdateCuadrillaReceptora)
    //         // update(ref(database, 'cuadrillas/' + state.cuadrillaReceptora),
    //         //     { seriales: formatSerialsToSave, controles: controlesCuadrillaReceptora })
    //         //     .then(() => {
    //         //         console.log('ok cuadrillas receptora', formatSerialsToSave, controlesCuadrillaReceptora)
    //         //     })
    //         //     .catch((e) => {
    //         //         setSnackbarInfo({ text: 'Ocurrió un error al guardar los seriales', type: 'error', open: true })
    //         //     })

    //         const indexSeriales = state.serialesToSave.map(serial => (
    //             serialesToSelect.findIndex((obj) => obj?.id === serial?.id)
    //         ))
    //         let newArrayCuadrilla = serialesToSelect;
    //         newArrayCuadrilla = newArrayCuadrilla?.filter((value, index) => indexSeriales.indexOf(index) === -1);
    //         newSerialesEntrega = newArrayCuadrilla || [];
    //         setNewSerialesEntrega(newSerialesEntrega);

    //         let newArrayControlsEntrega = controlsEntrega;

    //         if (state.controlsToSave.length > 0) {
    //             state.controlsToSave.forEach(control => {
    //                 const filterTipoControl = newArrayControlsEntrega.filter(cont => cont?.id === control?.id)
    //                 let newControlSave = [];
    //                 const keys = Object.keys(newArrayControlsEntrega);
    //                 if (filterTipoControl.length > 0) {
    //                     let materialNewArray = [...newArrayControlsEntrega]
    //                     const keyService = keys.filter(key => newArrayControlsEntrega[key]?.id === control?.id);
    //                     let materialToEdit = { ...materialNewArray[keyService] };
    //                     materialToEdit.value -= control.value
    //                     materialNewArray[keyService] = materialToEdit
    //                     newArrayControlsEntrega = materialNewArray
    //                 } else {
    //                     const formatControl = {
    //                         id: control?.id,
    //                         name: control.name,
    //                         value: -control.value
    //                     }
    //                     newControlSave = [...newArrayControlsEntrega, formatControl]
    //                     newArrayControlsEntrega = newControlSave
    //                 }
    //             })
    //         }

    //         const dataUpdateCuadrillaEntrega = { seriales: newSerialesEntrega, controles: newArrayControlsEntrega }
    //         updateCuadrillaFirestore(state.cuadrillaEntrega, dataUpdateCuadrillaEntrega)

    //         // update(ref(database, 'cuadrillas/' + state.cuadrillaEntrega),
    //         //     { seriales: newSerialesEntrega, controles: newArrayControlsEntrega })
    //         //     .then(() => {
    //         //         console.log('ok cuadrillas entrega', newSerialesEntrega, newArrayControlsEntrega)
    //         // setTimeout(() => {
    //         //     window.location.href = `/imprimir/${dataRemitoToSave?.id}`
    //         // }, 5000);
    //         //     })
    //         //     .catch((e) => {
    //         //         setSnackbarInfo({ text: 'Ocurrió un error al guardar los seriales', type: 'error', open: true })
    //         //     })
    //         // }, 500);
    //     }, 1500);
    // }
    // DEPRECADO


    const handleImport = ($event) => {
        const files = $event.target.files;
        if (files.length) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                const wb = read(event.target.result);
                const sheets = wb.SheetNames;

                if (sheets.length) {
                    const rawRows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                    const fechaActual = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm");
                    const rows = rawRows.map(item => {
                        const rawTipo = item.tipo || item.Tipo || item.TIPO || '';
                        const rawId = item.id !== undefined ? item.id : (item.Id !== undefined ? item.Id : (item.serial !== undefined ? item.serial : item.Serial));
                        const rawObs = item.observaciones || item.Observaciones || '';
                        return {
                            ...item,
                            tipo: typeof rawTipo === 'string' ? rawTipo.trim().toLowerCase() : (rawTipo ? String(rawTipo).trim().toLowerCase() : ''),
                            id: rawId !== undefined && rawId !== null ? String(rawId).trim() : '',
                            observaciones: typeof rawObs === 'string' ? rawObs.trim() : (rawObs ? String(rawObs).trim() : ''),
                            fechaUltimaModificacion: fechaActual // ✅ NUEVO: Agregar fecha de última modificación
                        };
                    });
                    setState(prevState => ({ ...prevState, serialesToSave: rows }));
                }
            }
            reader.readAsArrayBuffer(file);
        }
    }

    const handleClose = () => {
        setOpenModalSee(false);
        setOpenModalAdd(false);
    };

    const isValidSerial = (serial) => {
        const tipo = serial?.tipo ? String(serial.tipo).trim().toLowerCase() : '';
        const id = serial?.id !== undefined && serial?.id !== null ? String(serial.id).trim() : '';
        const isValid = Boolean(
            tipo !== '' &&
            id !== ''
        );

        if (!isValid) {
            console.log('❌ Serial inválido:', serial, {
                tipo: !!tipo,
                id: !!id,
                idNoVacio: id !== '',
                tipoId: typeof serial?.id
            });
        }

        return isValid;
    }

    const onAcceptSerials = () => {
        setOpenModalAdd(false);
        // state.serialesToSave?.forEach((serial, index) => {
        //     if (!isValidSerial(serial)) {
        //         state.serialesToSave?.splice(index, 1)
        //     }
        // })
    }

    const rows = [];
    for (let i = 0; i < 20; i++) {
        const serialCharge = state.serialesToSave[i] || { tipo: null, observaciones: '', id: '' };
        rows.push(inputSerials(i, serialCharge));
    }

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    const onChangeObservaciones = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleDownload = () => {
        // Definir los datos con el formato adecuado
        const data = [
            ['tipo', 'id', 'observaciones'],
            ['flow', '319102250', ''],
            ['ont', '4875444FC3A', ''],
            ['ext', '123456789', ''],
        ];

        // Crear una hoja de cálculo
        const ws = utils.aoa_to_sheet(data);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Sheet1');

        // Exportar como archivo Excel
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'seriales.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const updateMaterials = async () => {
        if (!state.materialsToSave || state.materialsToSave.length === 0) {
            return;
        }

        const getMaterialsFromCuadrilla = async (idCuadrilla) => {
            try {
                const materialsCollection = collection(firestore, 'materialsxcuadrilla');
                const idNum = parseInt(idCuadrilla, 10);
                const q = queryFire(
                    materialsCollection,
                    where('idCuadrilla', '==', idNum)
                );
                const querySnapshot = await getDocs(q);
                return querySnapshot.docs.map(docSnap => ({ ...docSnap.data(), docId: docSnap.id }));
            } catch (error) {
                console.error(`Error al obtener materialsxcuadrilla para cuadrilla ${idCuadrilla}:`, error);
                return [];
            }
        };

        const processMaterialUpdates = async (materialsEmisora, materialsReceptora) => {
            const updateMaterialStock = async (materialsArray, cuadrillaId, material, operation) => {
                const matIdNum = parseInt(material.id, 10);
                const matValueNum = parseInt(material.value, 10) || 0;
                if (matValueNum === 0) return;

                const existingMaterial = materialsArray.find(
                    (m) => m.idMaterial === matIdNum || Number(m.idMaterial) === matIdNum
                );

                const targetDocId = existingMaterial?.docId || `${cuadrillaId}c${material.id}`;
                const materialDocRef = doc(firestore, 'materialsxcuadrilla', targetDocId);

                const currentQty = existingMaterial && typeof existingMaterial.cantidad === 'number'
                    ? existingMaterial.cantidad
                    : (existingMaterial && Number(existingMaterial.cantidad)) || 0;

                const newQty = currentQty + (operation * matValueNum);

                const dataToStock = {
                    cantidad: newQty,
                    idCuadrilla: parseInt(cuadrillaId, 10),
                    idMaterial: matIdNum,
                };

                return setDoc(materialDocRef, dataToStock, { merge: true });
            };

            const updatePromises = [];

            // Actualizar materiales de la cuadrilla receptora (suma)
            state.materialsToSave.forEach((material) => {
                updatePromises.push(
                    updateMaterialStock(
                        materialsReceptora,
                        state.cuadrillaReceptora,
                        material,
                        1 // Operación suma
                    )
                );
            });

            // Actualizar materiales de la cuadrilla emisora (resta)
            state.materialsToSave.forEach((material) => {
                updatePromises.push(
                    updateMaterialStock(
                        materialsEmisora,
                        state.cuadrillaEntrega,
                        material,
                        -1 // Operación resta
                    )
                );
            });

            return Promise.all(updatePromises);
        };

        try {
            const [materialsEmisora, materialsReceptora] = await Promise.all([
                getMaterialsFromCuadrilla(state.cuadrillaEntrega),
                getMaterialsFromCuadrilla(state.cuadrillaReceptora)
            ]);
            await processMaterialUpdates(materialsEmisora, materialsReceptora);
            console.log('✅ updateMaterials completado con éxito');
        } catch (error) {
            console.error('Error en la actualización de materiales:', error);
            throw error;
        }
    };

    // ✅ FUNCIÓN SIMPLIFICADA: Validar que los seriales tengan estructura básica
    const validarEstructuraSeriales = (seriales, origen) => {
        console.log(`🔍 Validando estructura de seriales de ${origen}:`, seriales.length);
        
        if (!Array.isArray(seriales)) {
            console.error(`❌ ${origen}: No es un array`, seriales);
            return false;
        }
        
        // Simplificado: solo verificar que tengan ID (string o number)
        const serialesValidos = seriales.filter(serial => {
            const tieneId = serial && (serial.id !== null && serial.id !== undefined);
            return tieneId;
        });
        
        console.log(`🔍 ${origen}: ${serialesValidos.length}/${seriales.length} seriales con ID válido`);
        
        return true; // Siempre retornar true para no bloquear el proceso
    };

    // Helper para resolver la referencia correcta del documento de una cuadrilla
    const getCuadrillaDocRef = async (idCuadrilla) => {
        const directRef = doc(firestore, "cuadrillas", String(idCuadrilla));
        const directSnap = await getDoc(directRef);
        if (directSnap.exists()) {
            return { ref: directRef, snap: directSnap };
        }
        // Fallback: buscar por campo 'id' numérico
        const idNum = Number(idCuadrilla);
        if (!isNaN(idNum)) {
            const q = queryFire(collection(firestore, "cuadrillas"), where("id", "==", idNum));
            const qSnap = await getDocs(q);
            if (!qSnap.empty) {
                return { ref: qSnap.docs[0].ref, snap: qSnap.docs[0] };
            }
        }
        // Fallback: buscar por campo 'id' string
        const qStr = queryFire(collection(firestore, "cuadrillas"), where("id", "==", String(idCuadrilla)));
        const qStrSnap = await getDocs(qStr);
        if (!qStrSnap.empty) {
            return { ref: qStrSnap.docs[0].ref, snap: qStrSnap.docs[0] };
        }
        return { ref: directRef, snap: directSnap };
    };

    const updateCuadrillas = async (idRemito = null) => {
        console.log('🔄 === INICIO updateCuadrillas ===');
        console.log('🔄 ENFOQUE: Preservar TODOS los seriales existentes y agregar nuevos sin validaciones estrictas');
        console.log('🔄 Los IDs pueden ser string o number (desde Excel), se normalizan a string para comparación');
        console.log('🔄 Seriales a guardar:', state.serialesToSave);
        console.log('🔄 Cantidad de seriales:', state.serialesToSave?.length || 0);
        
        // ✅ VALIDAR ESTRUCTURA DE SERIALES A TRANSFERIR
        if (state.serialesToSave?.length > 0) {
            validarEstructuraSeriales(state.serialesToSave, 'Seriales a transferir');
        }

        // Validación inicial de datos
        if (!state.serialesToSave || !Array.isArray(state.serialesToSave)) {
            throw new Error("Los seriales a guardar no son válidos");
        }

        const idReceptora = state.cuadrillaReceptora;
        const idEmisora = state.cuadrillaEntrega;

        console.log('🔄 ID Receptora:', idReceptora);
        console.log('🔄 ID Emisora:', idEmisora);

        const isNucleoReceptora = Number(idReceptora) === idCuadrillaNucleo;
        const isNucleoEmisora = Number(idEmisora) === idCuadrillaNucleo;

        const { ref: docRefReceptora, snap: snapPreReceptora } = await getCuadrillaDocRef(idReceptora);
        const { ref: docRefEmisora } = await getCuadrillaDocRef(idEmisora);

        // Variables para uso fuera de la transacción (necesarias para el registro)
        let serialesExistentesEnEmisora = [];
        let serialesManuales = [];
        let serialesAagregar = []; // Para verificación posterior
        let serialesPreTransaccion = []; // Para recuperación de datos
        let serialesReceptoraOriginales = []; // Para usar fuera de la transacción

        try {
            // ✅ Obtener un snapshot ANTES de la transacción para comparación
            console.log('🔍 === SNAPSHOT PRE-TRANSACCIÓN ===');
            const dataPreTransaccion = snapPreReceptora.exists() ? snapPreReceptora.data() : {};
            serialesPreTransaccion = dataPreTransaccion?.seriales || [];
            console.log('🔍 Seriales en receptora ANTES de la transacción:', serialesPreTransaccion.length);
            
            await runTransaction(firestore, async (transaction) => {
                // Obtener datos actuales
                const [snapReceptora, snapEmisora] = await Promise.all([
                    transaction.get(docRefReceptora),
                    transaction.get(docRefEmisora),
                ]);

                if (!snapReceptora.exists() || !snapEmisora.exists()) {
                    throw new Error("Una de las cuadrillas no existe");
                }

                const dataReceptora = snapReceptora.data();
                const dataEmisora = snapEmisora.data();

                // Validar arrays básicos (emisora y controles)
                const serialesEmisora = Array.isArray(dataEmisora.seriales) ? dataEmisora.seriales : [];
                const controlesReceptora = Array.isArray(dataReceptora.controles) ? dataReceptora.controles : [];
                const controlesEmisora = Array.isArray(dataEmisora.controles) ? dataEmisora.controles : [];

                let serialesReceptoraParaUsar = [];
                if (Array.isArray(dataReceptora.seriales)) {
                    serialesReceptoraParaUsar = dataReceptora.seriales;
                } else if (serialesPreTransaccion.length > 0) {
                    serialesReceptoraParaUsar = serialesPreTransaccion;
                } else {
                    serialesReceptoraParaUsar = [];
                }
                
                const serialesReceptora = serialesReceptoraParaUsar;
                serialesReceptoraOriginales = serialesReceptora;

                // Sanitizar seriales antes de operar
                const serialesSanitizados = (state.serialesToSave || []).map(s => ({
                    ...s,
                    id: s?.id !== undefined && s?.id !== null ? String(s.id).trim() : '',
                    tipo: s?.tipo ? String(s.tipo).trim().toLowerCase() : '',
                    observaciones: s?.observaciones !== undefined && s?.observaciones !== null ? String(s.observaciones).trim() : ''
                }));

                // Separar seriales manuales de los que deben existir en emisora
                const serialesATransferir = serialesSanitizados.map(s => String(s.id).trim());
                serialesExistentesEnEmisora = serialesEmisora.filter(s => serialesATransferir.includes(String(s.id).trim()));
                serialesManuales = serialesSanitizados.filter(s =>
                    !serialesEmisora.some(se => String(se.id).trim() === String(s.id).trim())
                );

                const fechaActual = moment(new Date().getTime()).format("DD/MM/YYYY HH:mm");
                
                serialesAagregar = serialesSanitizados.filter(serial => {
                    const existe = serialesReceptora.some(sr => String(sr.id).trim() === String(serial.id).trim());
                    return !existe;
                }).map(serial => ({
                    ...serial,
                    id: String(serial.id).trim(),
                    tipo: String(serial.tipo).trim().toLowerCase(),
                    fechaUltimaModificacion: fechaActual,
                    tipoRemito: state.tipoRemito || 'TRANSFERENCIA'
                }));
                
                const nuevosSerialesReceptora = [
                    ...serialesReceptora,
                    ...serialesAagregar
                ];

                // Solo removemos de la emisora los seriales que efectivamente estaban allí
                const nuevosSerialesEmisora = serialesEmisora.filter(s =>
                    !serialesExistentesEnEmisora.some(se => String(se.id).trim() === String(s.id).trim())
                );

                // Manejar controles para la receptora
                let nuevosControlesReceptora = [...controlesReceptora];
                state.controlsToSave.forEach(control => {
                    const filterTipoControl = nuevosControlesReceptora.filter(cont => cont.id === control.id);
                    if (filterTipoControl.length > 0) {
                        nuevosControlesReceptora = nuevosControlesReceptora.map(cont =>
                            cont.id === control.id
                                ? { ...cont, value: cont.value + control.value }
                                : cont
                        );
                    } else {
                        nuevosControlesReceptora.push(control);
                    }
                });

                // Manejar controles para la emisora
                let nuevosControlesEmisora = [...controlesEmisora];
                state.controlsToSave.forEach(control => {
                    const filterTipoControl = nuevosControlesEmisora.filter(cont => cont.id === control.id);
                    if (filterTipoControl.length > 0) {
                        nuevosControlesEmisora = nuevosControlesEmisora.map(cont =>
                            cont.id === control.id
                                ? { ...cont, value: cont.value - control.value }
                                : cont
                        );
                    } else {
                        nuevosControlesEmisora.push({
                            id: control.id,
                            name: control.name,
                            value: -control.value
                        });
                    }
                });

                // Verificaciones de integridad básicas
                if (!isNucleoReceptora && nuevosSerialesReceptora.length < serialesReceptora.length) {
                    throw new Error("Error: Se perderían seriales en la receptora");
                }

                if (!isNucleoEmisora && nuevosSerialesEmisora.length > serialesEmisora.length) {
                    throw new Error("Error: Se generarían seriales extra en la emisora");
                }

                // Actualizar receptora (si no es Núcleo, actualizar seriales; si es Núcleo no acumulamos seriales)
                if (!isNucleoReceptora) {
                    transaction.update(docRefReceptora, {
                        seriales: nuevosSerialesReceptora,
                        controles: nuevosControlesReceptora,
                        ultimaActualizacion: serverTimestamp(),
                        ultimaModificacion: {
                            timestamp: serverTimestamp(),
                            serialesAgregados: state.serialesToSave.length,
                            serialesManuales: serialesManuales.length,
                            serialesTransferidos: serialesExistentesEnEmisora.length
                        }
                    });
                }

                // Actualizar emisora si no es Núcleo y había seriales o controles para transferir
                if (!isNucleoEmisora && (serialesExistentesEnEmisora.length > 0 || (state.controlsToSave && state.controlsToSave.length > 0))) {
                    transaction.update(docRefEmisora, {
                        seriales: nuevosSerialesEmisora,
                        controles: nuevosControlesEmisora,
                        ultimaActualizacion: serverTimestamp(),
                        ultimaModificacion: {
                            timestamp: serverTimestamp(),
                            serialesRemovidos: serialesExistentesEnEmisora.length
                        }
                    });
                }
            });

            console.log("✅ Transferencia de seriales completada con éxito");
            invalidateCuadrillasCache();

            // Verificar que los seriales se guardaron correctamente (si no es Núcleo)
            if (!isNucleoReceptora) {
                console.log('🔍 === VERIFICACIÓN POST-GUARDADO ===');
                const snapReceptoraFinal = await getDoc(docRefReceptora);
                const dataReceptoraFinal = snapReceptoraFinal.data();
                const serialesReceptoraFinal = dataReceptoraFinal?.seriales || [];

                const serialesTransferidos = state.serialesToSave.filter(serial =>
                    serialesReceptoraFinal.some(sr => String(sr.id) === String(serial.id))
                );
                console.log('✅ Verificación - Seriales transferidos exitosamente:', serialesTransferidos.length);
            }

            // Registrar la transferencia de seriales
            try {
                await registrarTransferenciaSeriales({
                    tipoOperacion: 'TRANSFERENCIA_REMITO',
                    componenteOrigen: 'AddRemito',
                    idRemito: idRemito || state.numeroRemito || `remito_${Date.now()}`,
                    idCuadrillaEmisora: idEmisora,
                    idCuadrillaReceptora: idReceptora,
                    serialesTransferidos: serialesExistentesEnEmisora,
                    serialesManuales: serialesManuales,
                    metadatos: {
                        tipoRemito: state.tipoRemito || 'TRANSFERENCIA',
                        fecha: new Date().toISOString(),
                        observaciones: state.observaciones || '',
                        usuarioActualizacion: currentUser?.email || 'SISTEMA'
                    }
                });
                console.log('✅ Registro de transferencia creado exitosamente');
            } catch (errorRegistro) {
                console.error('❌ Error al crear registro de transferencia:', errorRegistro);
                setSnackbarInfo({ 
                    text: 'Advertencia: El remito se guardó correctamente, pero no se pudo crear el registro de auditoría', 
                    type: 'warning', 
                    open: true 
                });
            }

            console.log('✅ === FIN updateCuadrillas ===');
        } catch (error) {
            console.error("❌ Error en la transferencia de seriales:", error);
            throw error;
        }
    };

    const verificarSerialesGuardados = async () => {
        try {
            console.log('🔍 === VERIFICANDO SERIALES GUARDADOS ===');
            const isNucleoReceptora = Number(state.cuadrillaReceptora) === idCuadrillaNucleo;
            
            if (isNucleoReceptora) {
                const serialesConDetalle = (state.serialesToSave || []).map(serialTransferido => ({
                    ...serialTransferido,
                    fechaTransferencia: new Date().toLocaleString(),
                    estadoVerificacion: 'CONFIRMADO'
                }));
                setSerialesVerificados(serialesConDetalle);
                setCuadrillaReceptoraInfo({
                    numero: 'NUCLEO S.A.',
                    totalSeriales: 0,
                    serialesTransferidos: serialesConDetalle.length
                });
                return serialesConDetalle;
            }

            // Obtener información de la cuadrilla receptora
            const { ref: docRefReceptora } = await getCuadrillaDocRef(state.cuadrillaReceptora);
            const snapReceptora = await getDoc(docRefReceptora);

            if (snapReceptora.exists()) {
                const dataCuadrilla = snapReceptora.data();
                const serialesActuales = dataCuadrilla.seriales || [];

                // Filtrar solo los seriales que acabamos de transferir
                const serialesTransferidos = state.serialesToSave.filter(serialTransferido =>
                    serialesActuales.some(serialActual => String(serialActual.id) === String(serialTransferido.id))
                );

                // Obtener información completa de los seriales verificados
                const serialesConDetalle = serialesTransferidos.map(serialTransferido => {
                    return {
                        ...serialTransferido,
                        fechaTransferencia: new Date().toLocaleString(),
                        estadoVerificacion: 'CONFIRMADO'
                    };
                });

                console.log('✅ Seriales verificados:', serialesConDetalle);

                setSerialesVerificados(serialesConDetalle);
                setCuadrillaReceptoraInfo({
                    numero: dataCuadrilla.numero,
                    totalSeriales: serialesActuales.length,
                    serialesTransferidos: serialesConDetalle.length
                });

                return serialesConDetalle;
            } else {
                console.error('❌ No se encontró la cuadrilla receptora');
                return [];
            }
        } catch (error) {
            console.error('❌ Error al verificar seriales guardados:', error);
            return [];
        }
    };

    const clearRemito = () => {
        // NOTA: No borramos serialesVerificados y cuadrillaReceptoraInfo
        // porque necesitamos mostrarlos en el feedback de éxito
        setState(
            prevState => ({
                ...prevState,
                materialsToSave: [],
                // NO limpiamos serialesToSave aquí porque lo necesitamos para la verificación
                // serialesToSave: [],
                tipoRemito: '',
                controlsToSave: [],
                // Mantenemos las cuadrillas para la verificación
                // cuadrillaEntrega: '',
                // cuadrillaReceptora: '',
                date: null,
                observaciones: '',
                shelfPosition: '', // Reset shelf position
                manualShelfPosition: '', // Reset manual shelf position
            }));
        setControlsDestino([]);
        setControlsEntrega([]);
        setSerialesToSelect([]);
        setNewSerialesEntrega([]);
        setSerialesCuadrillaDestino([]);
    }

    const saveAllData = async () => {
        console.log('💾 === INICIO saveAllData ===');
        console.log('💾 Estado antes de guardar:', {
            serialesToSave: state.serialesToSave?.length || 0,
            cuadrillaReceptora: state.cuadrillaReceptora,
            cuadrillaEntrega: state.cuadrillaEntrega
        });

        try {
            setOpenPreviewModal(false);
            setSpinner(true);

            console.log('💾 Ejecutando saveOnlyRemito para obtener ID...');
            // Primero guardar remito para obtener el ID real
            const idRemito = await saveOnlyRemito();
            console.log('💾 ID del remito generado:', idRemito);

            console.log('💾 Ejecutando updateCuadrillas con ID real...');
            // Luego actualizar cuadrillas con el ID real del remito
            await updateCuadrillas(idRemito);
            console.log('💾 updateCuadrillas completado');

            console.log('💾 Ejecutando updateMaterials...');
            // Finalmente actualizar materiales
            await updateMaterials();
            console.log('💾 updateMaterials completado');

            setSnackbarInfo({ text: 'Todos los datos fueron guardados correctamente.', type: 'success', open: true });

            console.log('💾 Verificando seriales guardados...');
            await verificarSerialesGuardados();
            console.log('💾 Verificación completada');

            setSaveOk(true);

            console.log('💾 Ejecutando clearRemito...');
            clearRemito();
            console.log('💾 clearRemito completado');
            console.log('💾 === FIN saveAllData ===');
        } catch (error) {
            console.error('❌ Error al guardar los datos:', error.message);
            setSnackbarInfo({ text: 'Ocurrió un error al guardar los datos.', type: 'error', open: true });
        } finally {
            setSpinner(false);
        }
    };

    const onClickPreview = () => {
        console.log('🔍 ANTES del filtrado:', state.serialesToSave?.length || 0, 'seriales');
        console.log('📝 Seriales originales:', state.serialesToSave);

        // Filtrar y limpiar seriales válidos correctamente
        const serialesValidos = (state.serialesToSave || [])
            .map(s => ({
                ...s,
                id: s?.id !== undefined && s?.id !== null ? String(s.id).trim() : '',
                tipo: s?.tipo ? String(s.tipo).trim().toLowerCase() : '',
                observaciones: s?.observaciones !== undefined && s?.observaciones !== null ? String(s.observaciones).trim() : ''
            }))
            .filter(serial => isValidSerial(serial));

        console.log('✅ DESPUÉS del filtrado:', serialesValidos.length, 'seriales válidos');
        console.log('📝 Seriales válidos:', serialesValidos);

        // Actualizar el estado correctamente
        setState(prevState => ({
            ...prevState,
            serialesToSave: serialesValidos
        }));

        setOpenPreviewModal(true);
    }

    return (
        <Container component="main">
            {saveOk ?
                (
                    <div>
                        {console.log('✅ Remito guardado - saveOk:', saveOk, 'lastId:', state.lastId)}
                        <Typography variant="h4" color="success.main" sx={{ marginBottom: '20px' }}>
                            ✅ Remito creado correctamente!
                        </Typography>

                        <Button
                            variant="contained"
                            size="large"
                            href={`/imprimir/${state.lastId}`}
                            sx={{ marginBottom: '15px' }}
                        >
                            Ver remito
                        </Button>

                        {/* Información de la cuadrilla receptora */}
                        {cuadrillaReceptoraInfo && (
                            <Paper sx={{ padding: '20px', marginBottom: '20px', backgroundColor: '#f8f9fa' }}>
                                <Typography variant="h6" color="primary" sx={{ marginBottom: '15px' }}>
                                    📦 Cuadrilla Receptora: {cuadrillaReceptoraInfo.numero}
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="body1">
                                            <strong>Total de seriales en cuadrilla:</strong> {cuadrillaReceptoraInfo.totalSeriales}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" color="success.main">
                                            <strong>Seriales transferidos:</strong> {cuadrillaReceptoraInfo.serialesTransferidos}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        )}

                        {/* Detalle de seriales verificados */}
                        {serialesVerificados.length > 0 && (
                            <Paper sx={{ padding: '20px', marginBottom: '20px' }}>
                                <Typography variant="h6" color="success.main" sx={{ marginBottom: '15px' }}>
                                    ✅ Seriales Verificados en Destino ({serialesVerificados.length})
                                </Typography>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>Tipo</strong></TableCell>
                                                <TableCell><strong>Serial</strong></TableCell>
                                                {state.tipoRemito === 'DEVOLUCION' && <TableCell><strong>NRO WO</strong></TableCell>}
                                                {state.tipoRemito === 'DEVOLUCION' && <TableCell><strong>Fecha de asistencia</strong></TableCell>}
                                                <TableCell><strong>Observaciones</strong></TableCell>
                                                <TableCell><strong>Última Modificación</strong></TableCell>
                                                <TableCell><strong>Estado</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {serialesVerificados.map((serial, index) => (
                                                <TableRow key={index} sx={{ backgroundColor: '#e8f5e8' }}>
                                                    <TableCell>{serial.tipo?.toUpperCase()}</TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                            {serial.id}
                                                        </Typography>
                                                    </TableCell>
                                                    {state.tipoRemito === 'DEVOLUCION' && <TableCell>{serial.nroWO || '-'}</TableCell>}
                                                    {state.tipoRemito === 'DEVOLUCION' && <TableCell>{serial.fechaAsistencia || '-'}</TableCell>}
                                                    <TableCell>{serial.observaciones || '-'}</TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                            {serial.fechaUltimaModificacion || 'No disponible'}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant="body2" color="success.main" sx={{ fontWeight: 'bold' }}>
                                                            ✅ {serial.estadoVerificacion}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        )}

                        {/* Mensaje si no hay seriales */}
                        {serialesVerificados.length === 0 && saveOk && (
                            <Paper sx={{ padding: '15px', marginBottom: '20px', backgroundColor: '#fff3cd' }}>
                                <Typography variant="body1" color="warning.main">
                                    ⚠️ No se transfirieron seriales en este remito
                                </Typography>
                            </Paper>
                        )}


                        {/* <Grid item xs={6}>
                                <Button 
                                    variant="outlined"
                                    size="large"
                                    onClick={() => {
                                        setSaveOk(false);
                                        setSerialesVerificados([]);
                                        setCuadrillaReceptoraInfo(null);
                                        setState(prevState => ({ 
                                            ...prevState, 
                                            lastId: -1,
                                            materialsToSave: [],
                                            serialesToSave: [],
                                            tipoRemito: '',
                                            controlsToSave: [],
                                            cuadrillaEntrega: '',
                                            cuadrillaReceptora: '',
                                            date: null,
                                            observaciones: ''
                                        }));
                                        setControlsDestino([]);
                                        setControlsEntrega([]);
                                        setSerialesToSelect([]);
                                        setNewSerialesEntrega([]);
                                        setSerialesCuadrillaDestino([]);
                                    }}
                                    fullWidth
                                >
                                    Crear nuevo remito
                                </Button>
                            </Grid> 
                            
                        </Grid> */}
                    </div>
                ) : (
                    <>
                        {spinner ? (
                            <CircularProgress />
                        ) : (
                            <>
                                <Grid item xs={12} sx={{ minWidth: '500px', marginBottom: '15px' }}>
                                    <FormControl sx={{ m: 1, width: '50%' }}>
                                        <InputLabel id="select-label-remito">Tipo Remito</InputLabel>
                                        <Select
                                            label="Tipo"
                                            onChange={onChangeTipoRemito}
                                            value={state.tipoRemito}
                                            className="select__form"
                                            input={<OutlinedInput label="Tipo Remito" />}
                                            sx={{ minWidth: '500px' }}
                                        >
                                            {tipoRemito.map((tipo) => (
                                                <MenuItem key={tipo} value={tipo}>
                                                    {tipo}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} sx={{ display: 'inline-flex' }}>
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DatePicker
                                            className="date-selector"
                                            label="Fecha estipulada entrega"
                                            inputFormat="DD/MM/YYYY"
                                            value={state.date}
                                            onChange={onChangeDate}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <FormControl sx={{ display: 'inline-flex', marginLeft: '10px', minWidth: '200px' }}>
                                    <Autocomplete
                                        options={cuadrillas}
                                        id="disable-clearable"
                                        disableClearable
                                        onChange={(e, cuadrilla) => onChangeCuadrillaEntrega(e, cuadrilla)}
                                        getOptionLabel={(option) => option.usuario ? `${option.usuario} - ${option.numero}` : (option.numero || '')}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        fullWidth
                                        renderInput={(params) => (
                                            <TextField {...params} label="Almacén origen" placeholder="Almacén origen" />
                                        )}
                                    />
                                </FormControl>
                                <FormControl sx={{ display: 'inline-flex', marginLeft: '10px', minWidth: '200px' }}>
                                    <Autocomplete
                                        options={cuadrillas}
                                        id="disable-clearable"
                                        disableClearable
                                        onChange={(e, cuadrilla) => onChangeCuadrillaDestino(e, cuadrilla)}
                                        getOptionLabel={(option) => option.usuario ? `${option.usuario} - ${option.numero}` : (option.numero || '')}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        fullWidth
                                        renderInput={(params) => (
                                            <TextField {...params} label="Almacén destino" placeholder="Almacén destino" />
                                        )}
                                    />
                                </FormControl>
                                {state.tipoRemito === 'ENTREGA' && (
                                    <>
                                        <FormControl sx={{ display: 'inline-flex', marginLeft: '10px', minWidth: '150px' }}>
                                            <Autocomplete
                                                options={shelfPositionOptions}
                                                id="shelf-position-selector"
                                                disableClearable
                                                value={state.shelfPosition}
                                                onChange={onChangeShelfPosition}
                                                getOptionLabel={(option) => option}
                                                fullWidth
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Posición de estante" placeholder="Seleccionar posición" />
                                                )}
                                            />
                                        </FormControl>
                                        {state.shelfPosition === 'Otra' && (
                                            <TextField
                                                variant="outlined"
                                                label="Posición"
                                                value={state.manualShelfPosition}
                                                onChange={onChangeManualShelfPosition}
                                                sx={{ marginLeft: '10px', minWidth: '100px' }}
                                            />
                                        )}
                                    </>
                                )}
                                {serialesToSelect && serialesToSelect.length > 0 &&
                                    <FormControl sx={{ m: 1, width: '50%' }}>
                                        <Autocomplete
                                            multiple
                                            id="checkboxes-tags-demo"
                                            options={serialesToSelect}
                                            disableCloseOnSelect
                                            value={state.serialesToSave}
                                            inputValue={serialInputValue}
                                            onChange={(e, serials) => onChangeSeriales(e, serials)}
                                            onInputChange={onSerialInputChange}
                                            getOptionLabel={(option) => option?.id}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderOption={(props, option, { selected }) => (
                                                <li {...props}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                    {option?.id}
                                                </li>
                                            )}
                                            style={{ width: '100%', margin: '10px 0' }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Seriales"
                                                    placeholder="Seriales"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        onKeyDown: (e) => {
                                                            if (e.key === 'Enter' && justAutoSelectedRef.current) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                justAutoSelectedRef.current = false;
                                                                return;
                                                            }
                                                            params.inputProps.onKeyDown?.(e);
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        {state.serialesToSave?.length > 0 &&
                                            state.serialesToSave.map(serial => (
                                                <Box
                                                    key={serial?.id}
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        marginBottom: '12px',
                                                        marginTop: '8px',
                                                    }}
                                                >
                                                    {state.tipoRemito === 'DEVOLUCION' && (
                                                        <>
                                                            <TextField
                                                                label={`NRO WO ${serial?.id}`}
                                                                className="text-form__serial"
                                                                value={serial?.nroWO || ''}
                                                                onChange={(e) => onChangeNroWOSerial(e, serial?.id)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ flex: '1 1 30%' }}
                                                            />
                                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                                <DatePicker
                                                                    label={`Fecha asistencia ${serial?.id}`}
                                                                    inputFormat="DD/MM/YYYY"
                                                                    value={serial?.fechaAsistencia ? moment(serial.fechaAsistencia, "DD/MM/YYYY") : null}
                                                                    onChange={(value) => onChangeFechaAsistenciaSerial(value, serial?.id)}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            sx={{ flex: '1 1 30%' }}
                                                                            InputLabelProps={{ shrink: true }}
                                                                        />
                                                                    )}
                                                                />
                                                            </LocalizationProvider>
                                                        </>
                                                    )}
                                                    <TextField
                                                        label={`Observaciones ${serial?.id}`}
                                                        className="text-form__serial"
                                                        value={serial?.observaciones || ''}
                                                        onChange={(e) => onChangeObservationSeriales(e, serial?.id)}
                                                        name="observaciones"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ flex: state.tipoRemito === 'DEVOLUCION' ? '1 1 35%' : '1 1 100%' }}
                                                    />
                                                </Box>
                                            ))

                                        }
                                    </FormControl>
                                }
                                {state.cuadrillaEntrega !== '' && (state.cuadrillaEntrega === idCuadrillaNucleo || serialesToSelect?.length === 0) &&
                                    <Grid item xs={6} sx={{ marginBottom: '20px' }}>
                                        <div className="custom-file">
                                            <div style={{ marginBottom: '20px' }}>
                                                <Button variant="outlined" onClick={handleDownload} endIcon={<FileDownloadIcon />}>
                                                    Planilla de ejemplo
                                                </Button>
                                            </div>
                                            <input type="file" name="file" className="custom-file-input" id="inputGroupFile" required onChange={handleImport}
                                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                            {state.serialesToSave?.length > 0 &&
                                                <Tooltip title="Ver detalle">
                                                    <IconButton
                                                        aria-label="see-more"
                                                        className="action__link"
                                                        onClick={(event) => {
                                                            event.preventDefault();
                                                            setOpenModalSee(true)
                                                        }}
                                                        role="button"
                                                    >
                                                        <VisibilityIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                        </div>
                                        {state.serialesToSave?.length > 0 &&
                                            <Dialog open={openModalSee} onClose={handleClose}>
                                                <DialogTitle>Listado de seriales</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer component={Paper}>
                                                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Tipo</TableCell>
                                                                    <TableCell>Número</TableCell>
                                                                    {state.tipoRemito === 'DEVOLUCION' && <TableCell>NRO WO</TableCell>}
                                                                    {state.tipoRemito === 'DEVOLUCION' && <TableCell>Fecha de asistencia</TableCell>}
                                                                    <TableCell>Observaciones</TableCell>
                                                                    <TableCell>Última Modificación</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {state.serialesToSave.map((row) => (
                                                                    <TableRow
                                                                        key={row?.id}
                                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                    >
                                                                        <TableCell component="th" scope="row">
                                                                            {row?.tipo?.toUpperCase()}
                                                                        </TableCell>
                                                                        <TableCell>{row?.id}</TableCell>
                                                                        {state.tipoRemito === 'DEVOLUCION' && <TableCell>{row?.nroWO || ''}</TableCell>}
                                                                        {state.tipoRemito === 'DEVOLUCION' && <TableCell>{row?.fechaAsistencia || ''}</TableCell>}
                                                                        <TableCell>{row.observaciones || ''}</TableCell>
                                                                        <TableCell>
                                                                            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                                                {row.fechaUltimaModificacion || 'No disponible'}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleClose}>Cerrar</Button>
                                                </DialogActions>
                                            </Dialog>
                                        }
                                    </Grid>
                                }
                                {state.cuadrillaEntrega !== '' &&
                                    <div>
                                        <Button
                                            variant="outlined"
                                            endIcon={<AddCircleOutlinedIcon />}
                                            onClick={(event) => {
                                                event.preventDefault();
                                                setOpenModalAdd(true)
                                            }}
                                        >
                                            Agregar seriales manualmente
                                        </Button>
                                        <Dialog
                                            open={openModalAdd}
                                            onClose={handleClose}
                                            maxWidth={state.tipoRemito === 'DEVOLUCION' ? 'xl' : 'md'}
                                            fullWidth
                                        >
                                            <DialogTitle>Agregar seriales</DialogTitle>
                                            <DialogContent>
                                                {rows}
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={onAcceptSerials}>Aceptar</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                }
                                <Stack direction="row" spacing={1} sx={{ marginTop: '30px', width: '97%' }}>
                                    {/* <TextField
                                        id="outlined-number"
                                        label="Control deco SAGEMCOM"
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        className="text-form__main-materials"
                                        onChange={(e) => onChangeControles(e, 0, 'sagemcom')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ margin: '0, 10px', flexBasis: '25%' }}
                                    />
                                    <TextField
                                        id="outlined-number"
                                        label="Control deco SAGEMCOM Reac."
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        className="text-form__main-materials"
                                        onChange={(e) => onChangeControles(e, 1, 'sagemcom reacondicionado')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ margin: '0, 10px', flexBasis: '25%' }}
                                    /> */}
                                    {/* <TextField
                                        id="outlined-number"
                                        label="Control deco Android"
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        className="text-form__main-materials"
                                        onChange={(e) => onChangeControles(e, 2, 'android')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ margin: '0, 10px', flexBasis: '50%' }}
                                    />
                                    <TextField
                                        id="outlined-number"
                                        label="Control deco Android Reac."
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        className="text-form__main-materials"
                                        onChange={(e) => onChangeControles(e, 3, 'android reacondicionado')}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ margin: '0, 10px', flexBasis: '50%' }}
                                    /> */}
                                </Stack>
                                <Box sx={{ display: 'flex', flexDirection: 'initial', marginTop: '40px' }} className="box-container">
                                    <FormControl component="fieldset" variant="standard">
                                        <FormGroup sx={{ flexDirection: 'initial' }}>
                                            {state?.materials?.map(material => {
                                                const matRecord = materialsCuadrillaReceptora.find(
                                                    mater => Number(mater.idMaterial) === Number(material?.id)
                                                );
                                                const preStock = matRecord
                                                    ? (parseInt(matRecord.cantidad, 10) || 0) - (parseInt(matRecord.preQuantity, 10) || 0)
                                                    : (state.cuadrillaReceptora !== '' ? 0 : '-');
                                                return (
                                                    material.visible &&
                                                    <>
                                                        <TextField
                                                            id="outlined-number"
                                                            label={material?.name}
                                                            type="number"
                                                            onWheel={(e) => e.target.blur()}
                                                            key={material?.id}
                                                            placeholder={`Pre-stock: ${preStock}`}
                                                            className="text-form__material"
                                                            onChange={(e) => changeInput(e, material?.id, material?.name)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            sx={{ flexBasis: '24%', margin: '7px 5px 7px 0' }}
                                                        />
                                                        {/* <TextField
                                            id="outlined-number"
                                            label={`Observaciones ${material?.name}`}
                                            type="string"
                                            key={material?.name}
                                            className="text-form__material"
                                            onChange={(e) => changeObservationsMaterials(e, material?.id)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{ flexBasis: '24%', margin: '7px 5px 7px 0' }}
                                        /> */}
                                                    </>
                                                )
                                            })}
                                        </FormGroup>
                                    </FormControl>
                                </Box>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        className="default__textfield"
                                        id="observaciones"
                                        label="Observaciones"
                                        value={state.observaciones}
                                        name="observaciones"
                                        sx={{ marginTop: '20px' }}
                                        onChange={onChangeObservaciones}
                                    />
                                </Grid>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="button__save"
                                    // onClick={saveRemito}
                                    onClick={onClickPreview}
                                    disabled={state.cuadrillaEntrega === '' || state.cuadrillaReceptora === '' || state.tipoRemito === '' || state.date === null}
                                    // onClick={() => setOpenPreviewModal(true)}
                                    sx={{ margin: '15px 0', width: '50%' }}
                                >
                                    Aceptar
                                </Button>
                            </>
                        )}
                        <Dialog
                            open={openPreviewModal}
                            onClose={() => setOpenPreviewModal(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            maxWidth="md"
                            fullWidth
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"Vista previa"}
                            </DialogTitle>
                            <DialogContent>
                                <FacturaRemito dataRemito={formatRemitoToSave(0)} isPreview={true} />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenPreviewModal(false)}>Cerrar</Button>
                                <Button onClick={saveAllData}>
                                    Guardar
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                            <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                                {snackbarInfo.text}
                            </Alert>
                        </Snackbar>
                    </>
                )}
        </Container>
    );
}

export default AddRemito
